export default __webpack_public_path__ + "static/media/264.719de682.jpg";